import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import WidgetContext from 'components/widget-context'

import HighYieldTile from '../../high-yield-tiles'
import {
  getEstimatedSavings,
  highYieldSavingsData,
  validDepositAmount,
  getApy,
  filterAvailableLenders,
} from '../lenders-data'

const HYSLendersList = ({ lenders, balanceAmount, pageFrom, pageTo, theme }) => {
  const value = useContext(WidgetContext)
  const sortAndSlice = (data) => {
    const filteredData = filterAvailableLenders(data, lenders)
    return filteredData
      .sort(
        (a, b) =>
          getApy(
            b.slug,
            b.slugVertical,
            lenders,
            validDepositAmount(b.minimumBalance, balanceAmount),
          )[0] -
          getApy(
            a.slug,
            a.slugVertical,
            lenders,
            validDepositAmount(a.minimumBalance, balanceAmount),
          )[0],
      )
      .slice(pageFrom, pageTo)
  }
  return (
    <div>
      {!!lenders.length &&
        sortAndSlice(highYieldSavingsData).map((lender, index) => {
          const {
            slug,
            fees,
            name,
            ctaUrl,
            minimumBalance,
            slugVertical,
            fdicInsured,
            productName,
          } = lender
          const validDeposit = validDepositAmount(minimumBalance, balanceAmount)
          const [apy, vertical] = getApy(slug, slugVertical, lenders, validDeposit)

          return (
            <HighYieldTile
              key={`${vertical}-${slug}`}
              slug={slug}
              fees={fees}
              name={name}
              vertical={vertical}
              ctaUrl={ctaUrl}
              minimumBalance={minimumBalance}
              fdicInsured={fdicInsured}
              productName={productName}
              balanceAmount={balanceAmount}
              WidgetContext={value}
              apy={apy}
              estimatedSavings={`$${getEstimatedSavings(apy, balanceAmount)}`}
              displayOrder={index + 1}
              theme={theme}
            />
          )
        })}
    </div>
  )
}
HYSLendersList.propTypes = {
  lenders: PropTypes.array,
  pageFrom: PropTypes.number,
  pageTo: PropTypes.number,
  balanceAmount: PropTypes.number,
  theme: PropTypes.string,
}

export { HYSLendersList }

export default HYSLendersList
